import FleetPulseFreightLogo from 'assets/images/logos/FleetPulseFreightLogo.svg';
import production from './production';
import staging from './staging';
import development from './development';
import test from './test';

const configVariants = {
  production,
  staging,
  development,
  test,
};
const config = {
  freshworksId: 43000003167,
  partner: {
    url: '', // UPDATE WHEN AVAILABLE
    name: 'FleetPulse Freight',
    partnerName: 'FleetPulse',
    logo: FleetPulseFreightLogo,
  },
  trailerSolution: true,
  ...configVariants[process.env.NODE_ENV || 'development'],
};

export default config;
